import { atom } from "jotai";
import type { HostsConfig } from "./hosts.config.types";

export const hostsAtom = atom<Partial<HostsConfig>>({});
